import { Stack } from '@mui/material'
import { FC, memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateLayerNum, updateTitleName } from 'store/withdraw/actions'
import { WithdrawLayoutType } from 'store/withdraw/types'
import Iconfont from '../../../components/Iconfont'
import { Space16 } from '../../../styles'
import {
  DepositTip,
  DepositTypeListWrap,
  DepositTypeOption,
  DepositTypeOptionDescribe,
  DepositTypeOptionTitle,
} from '../../Deposit/DepositSelectOption'
import { useTranslation } from 'react-i18next'
import { IconInfo } from 'components/Icons'
import { ReactComponent as IconWithdraw } from '../assets/withdraw.svg'
import { ReactComponent as IconTransfer } from '../assets/transfer.svg'

export const WithdrawLayoutSelection: FC<{
  isWithdraw?: boolean
}> = memo(({ isWithdraw }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <>
      <DepositTip>
        <IconInfo />
        {isWithdraw ? t('withdraw-options') : t('deposit-options')}
      </DepositTip>
      <Space16 />
      <DepositTypeListWrap>
        <DepositTypeOption
          onClick={() => {
            dispatch(updateLayerNum(WithdrawLayoutType.Withdraw))
            dispatch(updateTitleName(t('withdraw-to-layer1-title')))
          }}
        >
          <IconWithdraw />
          <Stack>
            <DepositTypeOptionTitle>
              {t('withdraw-to-layer1-title')}
            </DepositTypeOptionTitle>
            <DepositTypeOptionDescribe>
              {t('withdraw-to-layer1-describe')}
            </DepositTypeOptionDescribe>
          </Stack>
        </DepositTypeOption>
        <DepositTypeOption
          onClick={() => {
            dispatch(updateLayerNum(WithdrawLayoutType.Transfer))
            dispatch(updateTitleName(t('withdraw-to-layer2-title')))
          }}
        >
          <IconTransfer />
          <Stack>
            <DepositTypeOptionTitle>
              {t('withdraw-to-layer2-title')}
            </DepositTypeOptionTitle>
            <DepositTypeOptionDescribe>
              {t('withdraw-to-layer2-describe')}
            </DepositTypeOptionDescribe>
          </Stack>
        </DepositTypeOption>
      </DepositTypeListWrap>
    </>
  )
})
